import {
  AttendanceLocationUserStateTypes,
  AttendanceLocationUserActionTypes,
} from "./AttendanceLocationUser.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: AttendanceLocationUserStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
};

const AttendanceLocationUserReducer = (
  state: AttendanceLocationUserStateTypes = INITIAL_STATE,
  action: any
): AttendanceLocationUserStateTypes => {
  switch (action.type) {
    case AttendanceLocationUserActionTypes.FETCH_ALL_ATTENDANCE_LOCATION_USER:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case AttendanceLocationUserActionTypes.FETCH_ALL_ATTENDANCE_LOCATION_USER_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case AttendanceLocationUserActionTypes.FETCH_ALL_ATTENDANCE_LOCATION_USER_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case AttendanceLocationUserActionTypes.FETCH_ALL_ATTENDANCE_LOCATION_USER_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case AttendanceLocationUserActionTypes.FETCH_ONE_ATTENDANCE_LOCATION_USER:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case AttendanceLocationUserActionTypes.FETCH_ONE_ATTENDANCE_LOCATION_USER_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case AttendanceLocationUserActionTypes.FETCH_ONE_ATTENDANCE_LOCATION_USER_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case AttendanceLocationUserActionTypes.FETCH_ONE_ATTENDANCE_LOCATION_USER_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default AttendanceLocationUserReducer;
